import { usePlanningStore } from '@planning/AppProvider'
import { ContainerDamageReport } from '@planning/components/damage-report/ContainerDamageReport'
import { useTranslate } from '@tolgee/react'
import { observer } from 'mobx-react-lite'
import { FC } from 'react'
import { OrderDamagesButton, OrderDamagesButtonProps } from '../atoms/OrderDamagesButton'

type Props = OrderDamagesButtonProps & {
  containerId: number
  onSaveAdditionalInformation?: () => void
}

export const OrderDamagesDialogEditButton: FC<Props> = observer(props => {
  const { t } = useTranslate()
  const { appViewStore } = usePlanningStore()
  const { containerId, activeDamages, onSaveAdditionalInformation } = props

  const onClick = async () => {
    const isConfirm = await appViewStore.setOpenConfirmDialog(
      true,
      <ContainerDamageReport
        containerId={containerId}
        damages={activeDamages}
        callBackAfterResolveDamage={onSaveAdditionalInformation}
      />,
      t('viewDamages', 'View damages'),
      undefined,
      {
        hidePrimaryAction: true,
        secondaryActionText: t('cancel', 'Cancel'),
        maxWidth: 'sm',
      },
    )

    if (isConfirm) onSaveAdditionalInformation?.()
  }

  return <OrderDamagesButton {...props} onClick={onClick} />
})
